module.exports = __webpack_public_path__ + "static/media/consultadeuda.72f2cc0c.png";